var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "auth-saas auth-saas--pro", attrs: { id: "wrapper" } },
    [
      _c(
        "div",
        { staticClass: "auth-saas__layout auth-saas__layout--centered" },
        [
          _c("div", { staticClass: "auth-saas__form-column" }, [
            _c("div", { staticClass: "auth-saas__form-inner" }, [
              _c("div", { staticClass: "auth-saas__card" }, [
                _c("div", { staticClass: "auth-saas__user" }, [
                  _c("img", {
                    staticClass: "auth-saas__avatar",
                    attrs: {
                      src: _vm.getAuthUser("avatar"),
                      width: "72",
                      height: "72",
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "auth-saas__user-name" }, [
                    _vm._v(_vm._s(_vm.getAuthUser("full_name"))),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("h1", { staticClass: "auth-saas__title text-center" }, [
                  _vm._v(_vm._s(_vm.trans("auth.two_factor_security"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "auth-saas__subtitle text-center" }, [
                  _vm._v(
                    "Enter the verification code to finish signing in to the admin console."
                  ),
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "form-validate is-alter",
                    attrs: { id: "twoFactorForm" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submit.apply(null, arguments)
                      },
                      keydown: function ($event) {
                        return _vm.twoFactorForm.errors.clear(
                          $event.target.name
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "auth-saas__label text-center d-block",
                            attrs: { for: "two_factor_code" },
                          },
                          [_vm._v(_vm._s(_vm.trans("auth.two_factor_code")))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.twoFactorForm.two_factor_code,
                              expression: "twoFactorForm.two_factor_code",
                            },
                          ],
                          staticClass: "auth-saas__input text-center",
                          attrs: {
                            id: "two_factor_code",
                            type: "text",
                            name: "two_factor_code",
                            inputmode: "numeric",
                            autocomplete: "one-time-code",
                            placeholder: _vm.trans("auth.two_factor_code"),
                          },
                          domProps: {
                            value: _vm.twoFactorForm.two_factor_code,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.twoFactorForm,
                                "two_factor_code",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          staticClass: "text-danger text-center",
                          attrs: {
                            "form-name": _vm.twoFactorForm,
                            "prop-name": "two_factor_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "auth-saas__btn",
                          attrs: { type: "submit" },
                        },
                        [_vm._v(_vm._s(_vm.trans("auth.confirm")))]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "auth-saas__note" }, [
                  _c(
                    "a",
                    {
                      staticClass: "auth-saas__link-muted",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("admin-icon", { attrs: { name: "logout" } }),
                      _vm._v(" " + _vm._s(_vm.trans("auth.logout"))),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "auth-saas__footer" },
              [_c("guest-footer")],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center mb-2" }, [
      _c("span", { staticClass: "auth-saas__eyebrow" }, [
        _vm._v("Two-factor verification"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "auth-saas__mini-chip" }, [
      _c("span", {
        staticClass: "auth-saas__status-chip-dot",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Two-factor check")]),
      _vm._v(" "),
      _c("kbd", [_vm._v("2FA")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }